import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// Legacy constraints for reference:
// const constraints = {
//   label: {
//     type: 'string',
//     presence: { allowEmpty: false },
//   },
//   search_paths: {
//     presence: { allowEmpty: false },
//   },
// };
import Joi from 'joi';
import {
  map, filter as lodashFilter, reduce, first, cloneDeep,
} from 'lodash';
import {
  Modal, Button, FormGroup, ControlLabel,
  FormControl, HelpBlock,
} from 'react-bootstrap';
import Toggle from 'react-bootstrap-toggle';

import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import {
  addMeta, updateMeta,
} from '../custom-meta/actions';
import {
  updateTablePreferenceColumn, addTablePreferenceColumn,
} from '../../modules/App/AppActions';
import {
  getTablePreferenceMetaData,
} from '../../modules/App/AppReducer';
import MetaForm from './meta-form';
import SearchPath from '../search-path';

class ColumnForm extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
    this.cancel = this.cancel.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.submit = this.submit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.handleSelectField = this.handleSelectField.bind(this);
    this.onToggleCustom = this.onToggleCustom.bind(this);
    this.updateSearchPath = this.updateSearchPath.bind(this);
  }

  /*
  componentDidMount() {
    this.props.dispatch(loadTablePreferenceMetaData())
      .then(() => {
        this.checkProps(this.props);
        this.setState({ loading: false });
      });
  }
  */

  componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps);
  }

  updateSearchPath(paths) {
    this.props.change('search_paths', paths);
  }

  onToggleCustom() {
    const { selectedIsCustom } = this.props;
    this.props.change('is_custom', !selectedIsCustom);
    this.props.change('search_paths', []);
    this.props.change('target_custom_meta_id', null);
  }

  onSuccess() {

  }

  checkProps(props) {
    if (props.column && !props.isNew) {
      this.props.change('is_custom', props.column.target_custom_meta_id !== null && props.column.target_custom_meta_id !== undefined);
    }
  }

  cancel() {
    this.props.onCancel();
  }
  
  submitStandardColumn(params) {
    const { isNew, tableName, column } = this.props;
    const id = column._id;
    const action = isNew ? addTablePreferenceColumn(tableName, params) : updateTablePreferenceColumn(tableName, id, params);
    return this.props.dispatch(action)
      .then(
        (results) => {
          this.props.onSuccess(results.column);
        },
        (error) => {
          throw new SubmissionError(error.data || error);
        },
      );
  }

  submit(params) {
    const { selectedIsCustom, validCustomMetaObjects } = this.props;
    if (selectedIsCustom) {
      const newParams = cloneDeep(params);
      newParams.object_type = params.target_object;
      if (!newParams.object_type) {
        newParams.object_type = first(validCustomMetaObjects);
      }

      const isNewMeta = newParams.target_custom_meta_id === undefined || newParams.target_custom_meta_id === null;
      if (isNewMeta) {
        if (params.data_type === 'picklist') {
          newParams.values = reduce(newParams.values, (items, val) => {
            items.push({
              label: val.label,
              default: params.default_value === val.value,
            });
            return items;
          }, []);
          delete newParams.default_value;
        }
      } else {
        delete newParams.values;
      }
      const action = isNewMeta ? addMeta(newParams) : updateMeta(newParams.target_custom_meta_id, newParams);
      return this.props.dispatch(action)
        .then(
          (m) => {
            newParams.target_custom_meta_id = m._id;
            newParams.target_object = m.object_type; // TODO: remove this
            newParams.search_paths = [m.object_type];
            this.submitStandardColumn(newParams);
          },
          (error) => {
            const errorData = error.data || error;
            throw new SubmissionError(errorData);
          },
        );
    }
    return this.submitStandardColumn(params);
  }

  handleSelectField(field) {
    if (field.is_custom_meta) {
      this.props.change('target_custom_meta_id', field.name);
      this.props.change('search_paths', []);
    } else {
      this.props.change('target_custom_meta_id', null);
    }
  }

  getMetaLabel(meta) {
    return meta.type === 'User' ? 'Owner' : meta.type;
  }

  renderField({
    input, label, componentClass, type, meta: { touched, error }, options, readOnly,
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        {componentClass !== 'select' &&
          <FormControl
            {...input}
            componentClass={componentClass}
            placeholder={label}
            type={type}
            disabled={submitting || readOnly}
            readOnly={readOnly}
          />
        }
        {componentClass === 'select' &&
          <FormControl {...input} componentClass={componentClass} placeholder={label} type={type} disabled={submitting || readOnly}>
            <option />
            {options.map(o => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </FormControl>
        }
        {<FormControl.Feedback />}
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderCustomFieldToggle() {
    const { isNew, selectedIsCustom, validCustomMetaObjects } = this.props;
    if (!isNew || (!validCustomMetaObjects || validCustomMetaObjects.length === 0)) {
      // for editing: we don't allow to change
      return null;
    }
    return (
      <FormGroup>
        <ControlLabel>Column Type:</ControlLabel>
        <div>
          <Toggle
            onClick={this.onToggleCustom}
            on={<span>Standard</span>}
            off={<span>Custom</span>}
            size="xs"
            onstyle="success"
            offstyle="warning"
            active={!selectedIsCustom}
          />
        </div>
      </FormGroup>
    );
  }

  renderSearchPath() {
    const {
      selectedIsCustom,
      selectedSearchPaths,
      submitting,
    } = this.props;
    if (selectedIsCustom) {
      return null;
    }
    const object = first(this.props.validObjects);

    return (
      <FormGroup>
        <ControlLabel>Target Fields: {object}</ControlLabel>
        <SearchPath
          paths={selectedSearchPaths}
          disabled={submitting}
          onUpdate={this.updateSearchPath}
          startingNode={object}
          selectedSearchPaths={selectedSearchPaths}
        />
      </FormGroup>
    )
  }

  renderCustomMetaForm() {
    const {
      isNew, validCustomMetaObjects,
      selectedIsCustom, submitting,
    } = this.props;
    if (!selectedIsCustom) {
      return null;
    }
    /*
    let objects = map(metaData, m => ({
      value: m.type,
      label: m.type,
    }));
    if (validCustomMetaObjects !== null && validCustomMetaObjects !== undefined) {
      objects = lodashFilter(objects, o => indexOf(validCustomMetaObjects, o.value) >= 0);
    }
    */
    const objects = map(validCustomMetaObjects, m => ({
      value: m,
      label: m,
    }));

    const comps = [];
    if (objects.length > 1) {
      comps.push(<Field
        key="target-object"
        name="target_object"
        type="text"
        componentClass="select"
        options={objects}
        component={this.renderField}
        label="Target Object"
        readOnly={!isNew}
      />);
    }
    comps.push(<MetaForm
      key="meta-form"
      submitting={submitting}
      selectedDataType={this.props.selectedDataType}
      selectedDefaultValue={this.props.selectedDefaultValue}
      metaId={this.props.selectedTargetCustomMeta}
      onChange={this.props.change}
      values={this.props.column.values || []}
    />);

    return comps;
  }

  render() {
    const {
      handleSubmit, submitting, isNew,
      isRow, valid,
    } = this.props;
    let submitLabel = 'Save';
    if (isNew) {
      submitLabel = submitting ? 'Saving' : 'Save';
    } else {
      submitLabel = submitting ? 'Updating' : 'Update';
    }

    return (
      <div>
        <form onSubmit={handleSubmit(this.submit)}>
          <Modal.Body>
            <div>
              <Field name="label" type="text" component={this.renderField} label={isRow ? 'Row Label' : 'Column Label'} />
              <Field name="description" componentClass="textarea" component={this.renderField} label="Description" />
              {this.renderCustomFieldToggle()}
              {this.renderCustomMetaForm()}
              {this.renderSearchPath()}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="clearfix">
              <Button disabled={submitting} className="pull-left" bsStyle="link" onClick={this.cancel}>
                Cancel
              </Button>
              <Button type="submit" disabled={submitting || !valid} className="pull-right" bsStyle="primary">
                {submitLabel}
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </div>
    );
  }
}


ColumnForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  tableName: PropTypes.string.isRequired,
  column: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  initialValues: PropTypes.shape({}).isRequired,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
  validObjects: PropTypes.arrayOf(PropTypes.string),
  validCustomMetaObjects: PropTypes.arrayOf(PropTypes.string),
  metaData: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
    })),
  })).isRequired,
  isNew: PropTypes.bool,
  selectedTargetCustomMeta: PropTypes.string,
  initialize: PropTypes.func,
  change: PropTypes.func,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  selectedIsCustom: PropTypes.bool,
  selectedDataType: PropTypes.string,
  selectedDefaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  isRow: PropTypes.bool,
  requestEditCustomMeta: PropTypes.func,
  requestAddCustomMeta: PropTypes.func,
  valid: PropTypes.bool,
  selectedSearchPaths: PropTypes.arrayOf(PropTypes.string),
};
ColumnForm.defaultProps = {
  onSuccess: () => {},
  onCancel: () => {},
  validObjects: null,
  validCustomMetaObjects: null,
  handleSubmit: () => {},
  initialize: () => {},
  change: () => {},
  submitting: false,
  selectedTargetCustomMeta: null,
  selectedIsCustom: false,
  selectedDataType: null,
  selectedDefaultValue: null,
  isNew: false,
  isRow: false,
  requestEditCustomMeta: () => {},
  requestAddCustomMeta: () => {},
  valid: false,
  selectedSearchPaths: [],
};

const selector = formValueSelector('tablePreferenceColumnHyperForm');
function mapStateToProps(state, ownProps) {
  const selectedTargetCustomMeta = selector(state, 'target_custom_meta_id');
  const selectedIsCustom = selector(state, 'is_custom');
  
  const metaData = getTablePreferenceMetaData(state);
  const initialValues = { search_paths: [], ...ownProps.column };
  if (ownProps.column) {
    initialValues.data_type = ownProps.column.type;
  }
  return {
    initialValues,
    metaData,
    isNew: ownProps.column && ownProps.column._id === undefined,
    selectedTargetCustomMeta,
    selectedIsCustom,
    selectedSearchPaths: selector(state, 'search_paths'),
    selectedDataType: selector(state, 'data_type'),
    selectedDefaultValue: selector(state, 'default_value'),
  };
}


const schema = Joi.object({
  label: Joi.string().required().messages({
    'string.base': 'Label must be a string',
    'string.empty': 'Label is required',
    'any.required': 'Label is required',
  }),
  search_paths: Joi.any().required().messages({
    'any.required': 'Search paths are required',
  }),
}).unknown(true);

const validate = (values) => {
  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const ColForm = reduxForm({
  form: 'tablePreferenceColumnHyperForm',
  validate,
})(ColumnForm);

export default connect(mapStateToProps)(ColForm);
